(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grid-promo"] && !Shopify.designMode) return;
  try {
    /**
   * Removes the tile once it's outside its start and end times, in case the page came from cache,
   * and plays a video only while it's on screen.
   */
  class GridPromo extends HTMLElement {
    /** @type {IntersectionObserver | undefined} */
    observer;

    connectedCallback() {
      const now = Date.now() / 1000;
      const start = Number(this.dataset.start);
      const end = Number(this.dataset.end);
      if ((start && now < start) || (end && now >= end)) {
        this.closest('.grid-promo')?.remove();
        return;
      }

      const videos = this.querySelectorAll('video');
      if (!videos.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            const video = /** @type {HTMLVideoElement} */ (entry.target);
            if (entry.isIntersecting) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          }
        },
        { rootMargin: '200px' }
      );
      for (const video of videos) this.observer.observe(video);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('grid-promo')) customElements.define('grid-promo', GridPromo);
  } catch(e) { console.error(e); }
})();

})();
